import styled, { css } from 'styled-components';

import { ContentSwitcher as DefaultContentSwitcher } from '@xing-com/content-switcher';
import * as layoutTokens from '@xing-com/layout-tokens';
import * as tokens from '@xing-com/tokens';

const navigationHeight = '80px';
const mobileMargin = '20px';

type NavigationWrapperProps = {
  $isEditing?: boolean;
};
export const NavigationWrapper = styled.div<NavigationWrapperProps>`
  ${({ $isEditing }) => (!$isEditing ? 'position: relative;' : '')}
`;
export const Navigation = styled.div<{
  $isSticky: boolean;
  $isEditor: boolean;
}>`
  background-color: ${tokens.xdlColorBackground};
  overflow: hidden;

  ${({ $isSticky, $isEditor }) =>
    $isSticky &&
    css`
      position: fixed;
      top: ${tokens.scale170};
      z-index: 15;
      padding-top: 0;
      margin: 0;

      @media ${layoutTokens.mediaTopBarHidden} {
        top: ${tokens.scale210};
      }

      ${
        $isEditor &&
        css`
        @media ${layoutTokens.mediaWide} {
          top: 0;
        }
      `
      }
    `}
`;
export const NavigationContainer = styled.div`
  align-items: center;
  height: ${navigationHeight};
  display: flex;
  width: 100%;
`;
export const NavigationBorder = styled.div`
  border-bottom: 1px solid ${tokens.xdlColorBorderSoft};

  @media ${layoutTokens.mediaSmallOrTiny} {
    margin: 0 ${mobileMargin};
  }
`;
export const ContentSwitcherContainer = styled.div`
  flex: 1;
  overflow: hidden;

  @media (--mediaL) {
    flex: auto;
    width: 100%;
    overflow: auto;
  }
`;
export const ContentSwitcher = styled(DefaultContentSwitcher)`
  ul li:first-child button {
    margin-left: 0;
  }

  ul li:last-child button {
    margin-right: 0;
  }
  @media ${layoutTokens.mediaSmallOrTiny} {
    ul li:first-child button {
      margin-left: ${mobileMargin};
    }

    ul li:last-child button {
      margin-right: ${mobileMargin};
    }
  }
`;
export const InfoBanner = styled.div`
  @media ${layoutTokens.mediaSmallOrTiny} {
    margin: 0 ${mobileMargin};
  }
`;
